import React from 'react';
import './possibility.css';
import future from '../../assets/future.png';

const Possibility = () => {
  return (
    <div className="gpt3__possibility section__padding" id='possibility'>
      <div className='gpt3__possibilty-image'>
        <img src={future} alt="Future Image" />
      </div>

      <div className="gpt3__possibilty-content">
        <p>Request Early Access to Get Started</p>
        <h1 className='gradient__text'>The possibilities are beyond your imagination</h1>
        <p>Yet bed any for travelling assistance indulgence unpleasing. Not thoughts all exercise blessing. Indulgence way everything joy alteration boisterous the attachment. Party we years to order allow asked of.</p>
        <p>Request Early Access to Get Started</p>
      </div>
    </div>

  )
}

export default Possibility